import { render, staticRenderFns } from "./BoardPage.vue?vue&type=template&id=06e76f20&scoped=true"
import script from "./BoardPage.vue?vue&type=script&lang=ts"
export * from "./BoardPage.vue?vue&type=script&lang=ts"
import style0 from "./BoardPage.vue?vue&type=style&index=0&id=06e76f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e76f20",
  null
  
)

export default component.exports